var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_168_4080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.5 20 0 15.5 0 10C0 4.5 4.5 0 10 0C15.5 0 20 4.5 20 10C20 15.5 15.5 20 10 20ZM10 1.66667C5.41667 1.66667 1.66667 5.41667 1.66667 10C1.66667 14.5833 5.41667 18.3333 10 18.3333C14.5833 18.3333 18.3333 14.5833 18.3333 10C18.3333 5.41667 14.5833 1.66667 10 1.66667Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.8335C9.50002 10.8335 9.16669 10.5002 9.16669 10.0002V4.16683C9.16669 3.66683 9.50002 3.3335 10 3.3335C10.5 3.3335 10.8334 3.66683 10.8334 4.16683V10.0002C10.8334 10.5002 10.5 10.8335 10 10.8335Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 14.1665C13.0834 14.1665 12.9167 14.0832 12.75 13.9165L9.41669 10.5832C9.08335 10.2498 9.08335 9.74984 9.41669 9.4165C9.75002 9.08317 10.25 9.08317 10.5834 9.4165L13.9167 12.7498C14.25 13.0832 14.25 13.5832 13.9167 13.9165C13.75 14.0832 13.5834 14.1665 13.3334 14.1665Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_168_4080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/ic_clock.34668998233d6ba2be756bd0315044c4.svg";
export { ForwardRef as ReactComponent };